import React, { useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import { Box, Grid, TextField, Autocomplete, Chip, Button, Typography, FormHelperText, Paper, Divider, Avatar, IconButton, Tooltip } from "@mui/material";
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { deepPurple } from '@mui/material/colors';
import Select from "react-select";
import { State, City } from "country-state-city";
import { firestore, storage } from "../config/firebase";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { collection, getDocs, getDoc, setDoc, doc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { emailRegex, regexPattern } from "../utils/constants";
import countryOptions from "../jsonData/countries.json";
import languages from "../jsonData/language.json";
import "./form.css";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  state: "",
  city: "",
  experience: "",
  description: "",
};
const CounsellorForm = ({ toggleModal, refreshList, isModalVisible }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    state: "",
    city: "",
    experience: "",
    description: "",
  });
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateCode, setStateCode] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedLanguae, setSelectedLanguage] = useState([]);
  const fileInputRef = useRef(null);

  const handleValidation = () => {
    const newErrors = {};
    if (!formData.firstName || formData.firstName == "")
      newErrors.fName = "First name is required";
    else if (formData.firstName.length < 3 || formData.firstName.length > 50)
      newErrors.fName = "First name must be 3 to 50 characters long";

    if (!formData.lastName || formData.lastName == "")
      newErrors.lName = "Last name is required";
    else if (formData.lastName.length < 3 || formData.lastName.length > 50)
      newErrors.lName = "Last name must be 3 to 50 characters long";

    if (!formData.email || formData.email == "")
      newErrors.email = "Email is required";
    if (!formData.phone || formData.phone == "")
      newErrors.phone = "Phone number is required";
    if (formData.phone.length <= 9)
      newErrors.phone = "Phone number must be 10 digit long";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Enter a valid email address";

    if (!formData.city || formData.city == "") newErrors.city = "Select city";
    if (!formData.state || formData.state == "")
      newErrors.state = "Select state";
    if (!selectedCountries.length || selectedCountries.length === 0)
      newErrors.country = "Select countries";
    if (!selectedLanguae.length || selectedLanguae.length === 0)
      newErrors.country = "Select languages";
    if (!formData.experience || formData.experience === "")
      newErrors.exp = "Select experience";
    if (!formData.description || formData.description === "")
      newErrors.desc = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timeoutId = setTimeout(() => {
        setErrors({});
      }, 5000);

      // Clean up the timeout on component unmount
      return () => clearTimeout(timeoutId);
    }
  }, [errors]);

  const handleOnChange = (e) => {
    if (regexPattern.test(e.target.value)) {
      if (e.target.name === "firstName") {
        setFormData({ ...formData, firstName: e.target.value });
      } else setFormData({ ...formData, lastName: e.target.value });
    }
  };

  const handlePhoneNumberChange = (e) => {
    if (e.target.value.length < 11) {
      const cleanedText = e.target.value.replace(/[^0-9]/g, "");
      setFormData({ ...formData, phone: cleanedText });
    }
  };

  useEffect(() => {
    if (!stateList.length) {
      setStateList([
        ...State.getStatesOfCountry("IN").map((el, index) => {
          return { value: el.isoCode, label: el.name };
        }),
      ]);
    }
  }, [stateList]);

  useEffect(() => {
    if (stateCode) {
      setCityList([
        ...City.getCitiesOfState("IN", stateCode).map((el) => {
          return { label: el.name, value: el.name };
        }),
      ]);
    }
  }, [stateCode]);

  const generateUuid = (inputString) => {
    // Remove spaces from the input string and append current timestamp
    let characters = inputString?.replace(/\s+/g, "") + Date.now().toString();
    const charArray = characters.split("");

    // Shuffle the array of characters
    for (let i = charArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [charArray[i], charArray[j]] = [charArray[j], charArray[i]];
    }

    // Join the shuffled characters back into a string
    const shuffledString = charArray.join("");

    return shuffledString;
  };

  const handleAddCounsellor = async () => {
    const newErrors = {};
    let flag = handleValidation();
    if (flag) {
      try {
        const querySnapshot = await getDocs(
          collection(firestore, "councellors")
        );
        let result = querySnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter(
            (res) =>
              res.email === formData.email || res.phone === formData.phone
          );

        if (result.length && result.length > 0) {
          if (result[0].email === formData.email) {
            newErrors.email = "Email already registered";
          }
          if (result[0].phone === formData.phone) {
            newErrors.phone = "Phone number already registered";
          }
          setErrors(newErrors);
          return;
        }
        const uuid = generateUuid(formData.name);
        console.log("Step ----2");
        const countriesList = selectedCountries
          .map((e, i) => {
            return e.label;
          })
          .join(",");

        const languages = selectedLanguae
          .map((e, i) => {
            return e.label;
          })
          .join(",");
        const newData = {
          ...formData,
          isDeleted: false,
          country: "India",
          isActive: false,
          rating: 5,
          price: 0,
          uuid: uuid,
          fcm: "",
          access_token: "",
          isFeatured: false,
          isBlocked: false,
          status: false,
          image: selectedImage,
          dateJoined: Date.now(),
          totalStar: 0,
          feedbackCount: 0,
          specializeIn: countriesList,
          languages: languages,
        };

        const counsellorRef = doc(firestore, "councellors", formData.phone);
        await getDoc(counsellorRef);
        await setDoc(counsellorRef, newData);
        setFormData(initialState);
        toggleModal();
        refreshList();
      } catch (error) {
        console.error("Error adding new counsellor:", error);
      }
    }
  };

  const handleEditIconClick = (e) => {
    e.stopPropagation();
    fileInputRef.current.click();
  };
  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    let err = {};
    let ext = selectedFile.name;
    ext = ext.split(".");
    if (ext[1] === "svg") {
      err.image = "SVG images are not allowed";
      setErrors(err);
      return;
    } else {
      setErrors({});
    }
    if (selectedFile) {
      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      const storageRef = ref(storage, `counsellor_images/${uniqueFilename}`);
      uploadBytes(storageRef, selectedFile)
        .then((snapshot) => getDownloadURL(snapshot.ref))
        .then((downloadURL) => {
          setSelectedImage(downloadURL);
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const resetStates = async () => {
    if (selectedImage) {
      const oldImageRef = ref(storage, selectedImage);

      try {
        await deleteObject(oldImageRef);
        setFormData(initialState);
        setSelectedImage("");
      } catch (err) {
        console.log("Cannot delete image==========", err);
      }
    }
    setFormData(initialState);
    setErrors({});
    setStateCode("");
    setCityList([]);
    toggleModal();
  };

  const handleChange = (event, newValue) => {
    if (newValue.length < 3) {
      setSelectedCountries(newValue);
    }
  };

  const handleLanguageChange = (event, newValue) => {
    setSelectedLanguage(newValue);
  };

  // Custom styles for react-select to fix transparent backgrounds
  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#fff',
      borderColor: state.isFocused ? '#1976d2' : provided.borderColor,
      boxShadow: state.isFocused ? '0 0 0 2px #1976d233' : provided.boxShadow,
      minHeight: 40,
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#fff',
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#e3f2fd' : state.isFocused ? '#f1f1f1' : '#fff',
      color: '#222',
    }),
  };

  return (
    <Modal
      title={null}
      open={isModalVisible}
      onCancel={() => {
        resetStates();
      }}
      footer={null}
      centered
      style={{ padding: 0 }}
    >
      <Paper elevation={4} sx={{ p: 4, borderRadius: 3, maxWidth: 650, mx: 'auto', my: 2 }}>
        <Typography variant="h5" align="center" sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}>
          Add New Counsellor
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              position: "relative",
              mb: 1,
              '&:hover .avatar-overlay': { opacity: 1 },
              cursor: 'pointer',
            }}
            onClick={handleEditIconClick}
          >
            <Avatar
              sx={{ width: 80, height: 80, bgcolor: deepPurple[800], fontSize: 36 }}
              src={selectedImage}
              alt="Selected"
            >
              {!selectedImage && <PhotoCamera fontSize="large" />}
            </Avatar>
            <Box
              className="avatar-overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                bgcolor: 'rgba(33,150,243,0.65)',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                opacity: 0,
                transition: 'opacity 0.3s',
                zIndex: 2,
              }}
            >
              <Tooltip title="Change Image">
                <IconButton color="inherit" component="span" size="large">
                  <AddAPhotoIcon fontSize="large" />
                </IconButton>
              </Tooltip>
            </Box>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileInputChange}
            />
          </Box>
          {errors.image && <FormHelperText error>{errors.image}</FormHelperText>}
        </Box>
        <Box component="form" sx={{ width: "100%", mt: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleOnChange}
                error={!!errors.fName}
                helperText={errors.fName}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleOnChange}
                error={!!errors.lName}
                helperText={errors.lName}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                error={!!errors.email}
                helperText={errors.email}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handlePhoneNumberChange}
                error={!!errors.phone}
                helperText={errors.phone}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>State</Typography>
                <Select
                  onChange={async (a) => {
                    setStateCode(a.value);
                    setFormData({ ...formData, state: a.label, city: "" });
                  }}
                  options={stateList}
                  placeholder="Select state"
                  styles={selectStyles}
                />
                {errors.state && <FormHelperText error>{errors.state}</FormHelperText>}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              {cityList.length ? (
                <Box>
                  <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>City</Typography>
                  <Select
                    onChange={async (a) => {
                      setFormData({ ...formData, city: a.label });
                    }}
                    options={cityList}
                    placeholder="Select city"
                    styles={selectStyles}
                  />
                  {errors.city && <FormHelperText error>{errors.city}</FormHelperText>}
                </Box>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={countryOptions}
                getOptionLabel={(option) => option.label}
                value={selectedCountries}
                onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Select Countries"
                    placeholder="Select multiple countries"
                    error={!!errors.country}
                    helperText={errors.country}
                    size="small"
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.label}
                      {...getTagProps({ index })}
                      key={option.code}
                      sx={{ height: "20px", fontSize: "0.75rem", margin: "2px" }}
                    />
                  ))
                }
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={languages}
                getOptionLabel={(option) => option.label}
                value={selectedLanguae}
                onChange={handleLanguageChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Select Language"
                    placeholder="Select multiple languages"
                    error={!!errors.lang}
                    helperText={errors.lang}
                    size="small"
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.label}
                      {...getTagProps({ index })}
                      key={option.code}
                    />
                  ))
                }
                sx={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Experience</Typography>
                <Select
                  onChange={async (a) => {
                    setFormData({ ...formData, experience: a.label });
                  }}
                  options={[...Array(20).keys()].map((_, i) => {
                    return { label: (i + 1).toString(), value: (i + 1).toString() };
                  })}
                  placeholder="Select YoE"
                  styles={selectStyles}
                />
                {errors.exp && <FormHelperText error>{errors.exp}</FormHelperText>}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Description"
                variant="outlined"
                multiline
                rows={4}
                fullWidth
                placeholder="Type here..."
                value={formData.description}
                onChange={(e) => {
                  setFormData({ ...formData, description: e.target.value });
                }}
                error={!!errors.desc}
                helperText={errors.desc}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: "center", mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ px: 6, py: 1.5, fontWeight: 600, borderRadius: 2, boxShadow: 2, letterSpacing: 1 }}
                onClick={handleAddCounsellor}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Modal>
  );
};

export default CounsellorForm;
